import React from "react";
import { RouteComponentProps } from "react-router";
import { connect, ConnectedProps } from "react-redux";

import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Grid,
  Typography,
} from "@material-ui/core";
import * as GalleryStore from "../../../store/Gallery";
import IF from "../../common/IF";
import { ApplicationState } from "../../../store";

export enum GalleryGridPurpose {
  Albums = 0,
  Images = 1,
}

interface Props extends PropsFromRedux {
  elements: GalleryStore.GalleryElement[];
  purpose: GalleryGridPurpose;
}

const GalleryGrid: React.FC<Props & RouteComponentProps> = (props) => {
  return (
    <Grid style={{ flexGrow: 1, padding: 20 }} container>
      <Grid item xs={12}>
        <Grid container justify="center" spacing={2}>
          {props.elements
            .sort((a, b) => a.number - b.number)
            .map((element) => (
              <Grid key={element.id} item>
                <Card style={{ width: 300 }}>
                  <CardMedia
                    component="img"
                    height="190"
                    image={`./resources/images/gallery/small/${element.imageUrl.replace(
                      /^.*[\\/]/,
                      ""
                    )}`}
                    alt="green iguana"
                  />
                  <CardContent>
                    <Typography
                      gutterBottom
                      variant="h5"
                      component="div"
                      style={{
                        textOverflow: "ellipsis",
                        display: "inline-block",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        width: 268,
                      }}
                    >
                      {element.elementName}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button
                      size="small"
                      color="primary"
                      onClick={() => {
                        if (props.purpose === GalleryGridPurpose.Albums) {
                          props.history.push(`albums/${element.id}/edit`);
                        } else if (
                          props.purpose === GalleryGridPurpose.Images
                        ) {
                          props.history.push(`images/${element.id}/edit`);
                        }
                      }}
                    >
                      Edit
                    </Button>
                    <IF condition={props.purpose === GalleryGridPurpose.Albums}>
                      <Button
                        size="small"
                        color="primary"
                        onClick={() => {
                          props.history.push(`albums/${element.id}/images`);
                        }}
                      >
                        Images
                      </Button>
                    </IF>
                    <Button
                      size="small"
                      color="secondary"
                      onClick={async () => {
                        await props.deleteGalleryElement(element.id);
                      }}
                    >
                      Delete
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state: ApplicationState) => {
  return {
    gallery: state.gallery,
  };
};

const mapDispatch = {
  deleteGalleryElement: (elementId: number) =>
    GalleryStore.actionCreators.deleteGalleryElement(elementId),
};

const connector = connect(mapStateToProps, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(GalleryGrid);
